module.exports = __webpack_public_path__ + "static/media/custom-ex-13.0c67f33d.jpg";